export default "__VITE_ASSET__d847d5c5__"